import { type Locale } from '@framework/i18n/config.ts';
import { Dropdown } from '@framework/ui/components/dropdown/Dropdown.tsx';
import { MobileMenuLabel } from '@framework/ui/components/menu/MobileMenuLabel.tsx';
import { type ItemType } from 'antd/es/menu/interface';
import clx from 'classnames';
import { LanguageButton } from '../../ui/menu/LanguageButton.tsx';

interface MobileLanguageMenuProps {
  selected: Locale;
  locales: Locale[];
  onSelected: (locale: Locale) => void;
}

export function MobileLanguageMenu(props: MobileLanguageMenuProps) {
  const { selected, locales, onSelected } = props;
  const menuItems = locales.map(locale => ({
    key: locale.tag,
    label: (
      <MobileMenuLabel>{locale.nativeName ?? locale.name}</MobileMenuLabel>
    ),
    title: locale.label,
    onClick: () => onSelected(locale),
  })) satisfies ItemType[];

  return (
    <Dropdown
      menu={{ items: menuItems }}
      trigger={['click']}
      placement="bottomRight"
      autoFocus
      data-testid="mobile-language-menu"
    >
      <LanguageButton aria-haspopup className={clx(['selected'])}>
        {selected.label}
      </LanguageButton>
    </Dropdown>
  );
}
